import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';


@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private authService: AuthenticationService) {
    }
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url = state.url;
        let user = this.authService.getUserInfo();
        if (user && !user.IsFirstTimeLogin) {
            return true;
        }
        else if (user) {
            if (url != '/change-password') {
                this.router.navigate(['/change-password']);
            }
            return true;
        }
        else {
            this.authService.setRedirectUrl(url);
            this.router.navigate([this.authService.getLoginUrl()]);
        }
        return false;
    }
}
